import { render, staticRenderFns } from "./Update2.vue?vue&type=template&id=88eae9d0"
import script from "./Update2.vue?vue&type=script&lang=js"
export * from "./Update2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports